import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import QwikSelect from "components/form/QwikSelect";
import { useUpdateTransactionMutation } from "store/features/transaction/transactionManagementApi";

const EditTransactionModal = ({ isOpen, toggle, transaction, onTransactionUpdate }) => {
  const [updateTransaction, { isLoading }] = useUpdateTransactionMutation();

  const handleSubmit = async (data) => {
    try {
      await updateTransaction({ id: transaction.id, ...data }).unwrap();
      onTransactionUpdate();
    } catch (error) {
      console.error('Transaction update error:', error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Transaction</ModalHeader>
      <QwikForm onSubmit={handleSubmit} defaultValues={transaction}>
        <ModalBody>
          <Row>
            <Col lg={12}>
              <div className="mb-3">
                <QwikSelect
                  name="transaction_type"
                  label="Transaction Type"
                  options={[
                    { value: "earning", label: "Earning" },
                    { value: "cost", label: "Cost" }
                  ]}
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="amount"
                  label="Amount"
                  placeholder="Enter amount"
                  type="number"
                  step="0.01"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="date"
                  label="Date"
                  type="date"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="description"
                  label="Description"
                  placeholder="Enter transaction description"
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={toggle}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {isLoading ? "Updating..." : "Update Transaction"}
          </Button>
        </ModalFooter>
      </QwikForm>
    </Modal>
  );
};

export default EditTransactionModal;